const QuickViewDesignModal = (modalId: string) => {
  const overlay = document.getElementById(modalId);
  const closeButtons = overlay?.querySelectorAll<HTMLButtonElement>(
    '.js-btn-modal-close',
  );
  let isModalOpen = false;

  const open = (id: number) => {
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      isModalOpen = true;

      fetchData(id);
      // Add event listener to overlay only if not already added
      if (!overlay.classList.contains('modal-listener-attached')) {
        overlay.addEventListener('click', handleOutsideClick);
        overlay.classList.add('modal-listener-attached');
      }
    }
  };

  const close = () => {
    if (overlay && isModalOpen) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      isModalOpen = false;

      // Remove event listener only if present
      if (overlay.classList.contains('modal-listener-attached')) {
        overlay.removeEventListener('click', handleOutsideClick);
        overlay.classList.remove('modal-listener-attached');
      }
    }
  };

  const fetchData = (id: number) => {
    const _url = `/quick-view/designs/${id}`;

    fetch(_url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.text();
      })
      .then(html => {
        // Get the div element where the content will be embedded
        const contentDiv = document.getElementById('js-quickview-content');

        // Set the HTML content of the div
        if (contentDiv) {
          contentDiv.innerHTML = html;
        }
      })
      .catch(error => {
        console.error(
          'There has been a problem with your fetch operation:',
          error,
        );
      });
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (isModalOpen) {
      // Check if the click target is the overlay itself, not the child elements
      if (event.target === overlay) {
        console.log('Click outside detected');
        close();
      }
    }
  };

  closeButtons?.forEach(closeButton => {
    closeButton.addEventListener('click', close);
  });

  return {
    open,
    close,
  };
};

export default QuickViewDesignModal;
